<template>
  <div>
      <div style="text-align: end; margin-bottom: 10px;padding-right: 56px;" >
         <el-button type="primary" v-if="ishandleEide"  @click="handleEide"  :disabled="isView">编辑</el-button>
      </div>
      <div style="display: flex;">

        <div style="width: 420px;">
          <div class="menu-container">
            <el-input
              v-model="searchText"
              placeholder="搜索页面或目录..."
              prefix-icon="el-icon-search"
              clearable
              @input="handleSearch"
            />

            <div style="display: flex; justify-content: space-between;  padding: 10px;">
              <span style="margin-right: 160px;">目录</span>
              
              <el-dropdown trigger="click" :disabled="isView">
                <el-tooltip class="item" effect="dark" content="新建目录" placement="top-start">
                  <span class="add-directory-btn">
                    <i class="el-icon-plus"></i>
                  </span>
                </el-tooltip>
                <el-dropdown-menu style="padding-left: 19px;" slot="dropdown">
                  <el-dropdown-item @click.native.stop="handleAdds">
                    <svg style="margin-top: 8px;  position: absolute;  margin-left: -22px;" width="20" height="20" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 8C5 6.89543 5.89543 6 7 6H19L24 12H41C42.1046 12 43 12.8954 43 14V40C43 41.1046 42.1046 42 41 42H7C5.89543 42 5 41.1046 5 40V8Z" fill="#51b3f1" stroke="#51b3f1" stroke-width="4" stroke-linejoin="miter"/>
                      <path d="M24 20L26.243 24.9128L31.6085 25.5279L27.6292 29.1792L28.7023 34.4721L24 31.816L19.2977 34.4721L20.3708 29.1792L16.3915 25.5279L21.757 24.9128L24 20Z" fill="#FFF" stroke="#FFF" stroke-width="4" stroke-linecap="square" stroke-linejoin="miter"/>
                    </svg>
                    添加目录
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            
             <el-menu    :default-active="activeItemId" :default-openeds="defaultOpeneds" :key="menuKey" style="height: 70vh; overflow: auto;" class="el-menu-vertical-demo"   @open="handleopen"  @close="handleclose" >
                <menu-item
                  v-for="(item,index) in menuData"
                  :key="item.id"
                  :item="item"
                  @open="handleopen"
                  @close="handleclose"
                  :active-item-id="activeItemId"
                  @command="handleCommand"
                  @item-click="handleItemClick" />
             </el-menu>

          </div>
        </div>

        <el-dialog :title="titles" :visible.sync="dialogTableVisible" :before-close="ClrdialogTableVisible" width="50%" modal-append-to-body append-to-body :close-on-click-modal="false">
            <div>
              <el-input clearable size="small" placeholder="请输入目标名称" v-model="searchTextinput" ></el-input>
            </div>
            <div class="dialog-footer" style="text-align: end;padding-top: 30px;">
              <div style="text-align: end;">
                <el-button size="small" @click="ClrdialogTableVisible">取 消</el-button>
                <el-button size="small" type="primary" @click="SnutdialogTableVisible">确 定</el-button>
              </div>
            </div>
        </el-dialog>


        <div style="width: 80%;">
          <vue-components style="height: 75vh;"  v-model="content" ref="myQuillEditors" :options="editorOptions"></vue-components>
        </div>
        

      </div>


      <el-dialog  :visible.sync="isvueCKEditorLoding" :before-close="ClrisvueCKEditorLoding" class="newdialog" width="100%" modal-append-to-body append-to-body :close-on-click-modal="false">
         <vueCKEditorLoding :Row="Row" :content="content" v-if="isvueCKEditorLoding"  @handleSvenReree="handleSvenReree"></vueCKEditorLoding>
      </el-dialog>


      <div id="lightbox" style="display:none; position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,.8); z-index:9999; justify-content:center; align-items:center;">
        <img id="lightbox-image" style="max-width:90%; max-height:90%;">
      </div>
            
  </div>
</template>

<script>

import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import loadingUtils from "../utils/loading";
import 'animate.css'

import vueCKEditorLoding from './CKEditorLoding.vue'
import MenuItem from './MenuItem.vue'


import axios from "axios";
import apiBaseUrl from "../../config/api";

export default {
  components: {
    vueCKEditorLoding,
    MenuItem,
  },
  data() {
    return {

        isView: false,

        menuKey: 0,
        titles: '',

        defaultOpeneds: [],

        activeItemId: 1, // 当前选中的项ID

        searchTextinput: '',
        dialogTableVisible: false,

        ishandleEide: false,
        searchText: '',

        activeIndex: 1,
        defaultOpened: [1],
        menuData:[],

        content:'',
        editorOptions: {
          theme: 'snow',
          placeholder: '...',
          modules: {
            toolbar: false 
          },
       
        },


        isvueCKEditorLoding: false,

        Row:{ },
    
    }
  },

  mounted() {

    axios.get(`${apiBaseUrl}/wikiCategory/getUserWikiJur`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then(response => {
      if (response.data && response.data.code === 200) {
          this.isView = response.data.data ? false : true
      } else {
          this.isView = true
          this.$message.error(response.data.message || response.data.meg);
      }
    }).catch((error) => {
       this.isView = true
       this.$message.error(error);
    });
    
    this.$refs.myQuillEditors.quill.enable(false)
    
    document.querySelector('.ql-editor').addEventListener('click', function(e) {
      if (e.target.tagName === 'IMG') { 
        const imgSrc = e.target.src;
        document.getElementById('lightbox-image').src = imgSrc;
        document.getElementById('lightbox').style.display = 'flex'; 
      }
    });

    document.getElementById('lightbox').addEventListener('click', function() {
      this.style.display = 'none'; 
    });


    this.handleGetOrgTree()
    
  },

  methods: {


    handleGetOrgTree(){
      axios.get(`${apiBaseUrl}/wikiCategory/getOrgTree?wikiName=${this.searchText ? this.searchText : ''}`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then(response => {
        if (response.data && response.data.code === 200) {
          this.menuData = response.data.data
          console.log('树数据:', this.menuData);
        } else {
          this.$message.error(response.data.message || response.data.meg);
        }
      }).catch((error) => {
        this.$message.error(error);
      });
    },

    handleSvenReree(currentActiveId) {
      this.isvueCKEditorLoding = false
      this.activeItemId = currentActiveId
      this.menuKey += 1
      this.handleGetOrgTree()
      axios.get(`${apiBaseUrl}/wikiDocument/getOne/${currentActiveId}`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then(response => {
        if (response.data.code === 200) {
            this.content = response.data.data.content ? response.data.data.content : '' 
            this.$refs.menu.open(currentActiveId)
        } else {
          this.$message.error(response.data.message || response.data.meg);
        }
      }).catch((error) => {})
    },

    ClrisvueCKEditorLoding() {
      this.isvueCKEditorLoding = false 
    },

    handleItemClick(item) {
      this.Row = item
      this.activeItemId = item.id;
      this.ishandleEide = item.isCatalogue
      console.log('选中项:', item);


      if(item.isCatalogue === 1){
          axios.get(`${apiBaseUrl}/wikiDocument/getOne/${item.id}`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then(response => {
            if (response.data.code === 200) {
                if(response.data.data && response.data.data.content){
                  this.content = response.data.data.content ? response.data.data.content : '' 
                }else{
                  this.content = ''
                }
            } else {
              this.$message.error(response.data.message || response.data.meg);
            }
         }).catch((error) => {})
      }else{
          this.content = ''
      }
    },


    SnutdialogTableVisible() {
      if(this.searchTextinput){

        if(this.titles === '新建目录' || this.titles === '新建页面'){
          let isCatalogue = this.titles === '新建目录' ? 0 : 1
          let parentId = this.Row ? this.Row.id : 0 
          axios.post(`${apiBaseUrl}/wikiCategory/create`, { "parentId": parentId,  "wikiName": this.searchTextinput , isCatalogue },{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(response => {
            if (response.data && response.data.code === 200) {
              this.$message.success( this.titles + '成功')
              this.searchTextinput = ''
              this.dialogTableVisible = false
              this.handleGetOrgTree()
            } else {
              this.$message.error(response.data.message || response.data.meg);
            }
          }).catch((error) => {
            this.$message.error(error);
          });  
        }

        if(this.titles === '修改文档名称' || this.titles === '修改目录名称'){
          axios.post(`${apiBaseUrl}/wikiCategory/update`, { "id": this.Row.id,  "wikiName": this.searchTextinput },{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(response => {
            if (response.data && response.data.code === 200) {
              this.$message.success('新建目录成功')
              this.searchTextinput = ''
              this.dialogTableVisible = false
              this.handleGetOrgTree()
            } else {
              this.$message.error(response.data.message || response.data.meg);
            }
          }).catch((error) => {
            this.$message.error(error);
          });
        }
      }else{
        this.$message.warning('请输入目录名称')
        return
      }
    },
    

    ClrdialogTableVisible() {
      this.searchTextinput = ''
      this.dialogTableVisible = false
    },

    handleEide(key, keyPath) {
      console.log(key, keyPath)
      this.isvueCKEditorLoding = true
    },

    handleSearch(value) {
      console.log('搜索:', value)
      this.handleGetOrgTree()
    },

    handleclose() {
      this.content = ''
      this.ishandleEide = false
    },

    handleopen() {
      this.content = ''
      this.ishandleEide = false
    },

    handleCommand(command, item) {
      switch (command) {
        case 'add':
          this.addPage(item)
          break
        case 'adds':
          this.Row = item
          this.titles = '新建目录'
          this.dialogTableVisible = true
          break
        case 'rename':
          this.renameItem(item)
          break
        case 'renames':
          this.renameItems(item)
          break
        case 'deletes':
          this.deleteItems(item)
          break
        case 'delete':
          this.deleteItem(item)
          break
      }
    },

    addPage(directory) {
      console.log('在目录', directory, '中添加页面')
      this.titles = '新建页面'
      this.dialogTableVisible = true
      this.Row = directory
    },

    renameItem(item) {
      this.titles = '修改文档名称'
      this.dialogTableVisible = true
      this.Row = item
      this.searchTextinput = item.wikiName
      console.log('重命名:', item)
    },

    renameItems(item) {
      this.titles = '修改目录名称'
      this.dialogTableVisible = true
      this.Row = item
      this.searchTextinput = item.wikiName
      console.log('重命名:', item)
    },

    deleteItem(item) {
      this.$confirm('确定删除该文档吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log('删除:', item.title)
        axios.post(`${apiBaseUrl}/wikiCategory/delete/${item.id}`,{},{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(response => {
          
          if (response.data && response.data.code === 200) {
            this.$message.success('删除成功')
            this.handleGetOrgTree()
          } else {
            this.$message.error(response.data.message || response.data.meg);
          }
        }).catch((error) => {
          this.$message.error(error);
        });
      })
    },

    deleteItems(item) {
      // 二次确认
      this.$confirm('确定删除该目录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log('删除:', item.title)
        axios.post(`${apiBaseUrl}/wikiCategory/delete/${item.id}`,{}, {headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(response => {
          if (response.data && response.data.code === 200) {
            this.$message.success('删除成功')
            this.handleGetOrgTree()
          } else {
            this.$message.error(response.data.message || response.data.meg);
          }
        }).catch((error) => {
          this.$message.error(error);
        });
      })
    },

    handleAdds() {
       this.titles = '新建目录'
       this.Row.id = 0
       this.dialogTableVisible = true
    }

  },

}
</script>

<style scoped lang="less">
.menu-container {
  padding: 0px 10px;
}

.more-actions {
  position: absolute;
  right: 50px;
  top: 50%;
  transform: translateY(-50%);
}

.el-dropdown-link {
  cursor: pointer;
}

.el-dropdown-link:hover {
  color: #409EFF;
}


.newdialog /deep/ .el-dialog{
   margin-top: 0 !important;
   height: 100%;
}


/deep/ .el-submenu__title{
  margin-left: 15px;
}

#lightbox {
  display: none;
  justify-content: center;
  align-items: center;
}

#lightbox img {
  border-radius: 4px;
  transition: all .3s ease-in-out;
}

</style>


// WEBPACK FOOTER //
// src/CKEditor/CKEditor.vue